import React, { useEffect, useState } from "react";

import { size, isEmpty } from "lodash";

import NoDataFound from "../common/NoDataFound";

function ServiceInfo(props) {
  const data = props.data;
  const cInfo = props.cInfo;
  const [showNoData, setShowNoData] = useState(true);
  const [isReadMore, setIsReadMore] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  // const handleReadMore = () => {
  //   setIsReadMore(true);
  // }
  // const handleReadLess = () => {
  //   setIsReadMore(false);
  // }

  // const toggleRead = () => {
  //   setIsReadMore(!isReadMore);
  // };

  useEffect(() => {
    if (size(data) > 0) {
      setShowNoData(false);
    } else {
      setShowNoData(true);
    }
  }, [props.data]);


  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
    setIsReadMore(!isReadMore);
  };

  return (
    <div className="service-section">
      {/* <h4 className="mt-0">
        <img src={ServicesIcon} alt="" className="company-info-icon mx-1" />
        Services Information
      </h4> */}
      <h3>Services Information</h3>

      <div className="company-service-inf">

        <div className="outer">

          <ul id="portfolio" className={isExpanded ? "readmore" : ""}>
            {!showNoData &&
              !isReadMore &&
              data.slice(0, 9).map((val, k) => (
                <li key={k}>
                  <i className="fa-solid fa-arrow-right"></i>
                  {
                    cInfo.trade_mode_type === 'LOG_PTR'
                      ? val.services.service_name +
                      (!isEmpty(val.services.parent_service) ? ' (' + val.services.parent_service + ')' : '')
                      : val.services.service_name
                  }
                </li>
              ))}
            {!showNoData &&
              isReadMore &&
              data.map((val, k) => (
                <li key={k}>
                  <i className="fa-solid fa-arrow-right"></i>
                  {
                    cInfo.trade_mode_type === 'LOG_PTR'
                      ? val.services.service_name +
                      (!isEmpty(val.services.parent_service) ? ' (' + val.services.parent_service + ')' : '')
                      : val.services.service_name
                  }
                </li>
              ))}

            <div className="no-data">{showNoData && <NoDataFound />}</div>
          </ul>
          {
            !showNoData && (size(data) > 9) ? (
              <div id="expandbtn" onClick={toggleReadMore} className="services-read-more-text">
                <i className={isExpanded ? "fa fa-arrow-up" : "fa fa-arrow-down"}></i>
                {isExpanded ? " Read Less" : " Read More..."}
              </div>
            ) : ""
          }
        </div>

        <div>
          {/* {
            (!showNoData && !isReadMore) && data.slice(0, 7).map((val, k) => (<p key={k}><i className="fa-solid fa-arrow-right"></i>{val.services.service_name}</p>))
          } */}
          {/* { (!showNoData && isReadMore) && data.map((val, k) => (<p key={k}><i className="fa-solid fa-arrow-right"></i>{val.services.service_name}</p>))
          } */}
          {/* {(!showNoData && !isReadMore) && <span onClick={handleReadMore}>Read more...</span>}
          {(!showNoData && isReadMore) && <span onClick={handleReadLess}>Read less...</span>} */}
          {/* {(!showNoData && size(data) > 7) && <div onClick={toggleRead} className='services-read-more-text'>{isReadMore ? "Read less" : "Read more..."}</div>} */}
        </div>

      </div>
    </div>
  );
}

export default ServiceInfo;
